'use client';

// import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import styled from 'styled-components';

import Header from './Header';
import ListOfGuides from './ListOfGuides';
import { ManualMainMain, ManualMain } from '@/ui/components/Manual/manual.styled';
import ParsedContent from '@/ui/components/ParsedContent';
import { log } from '@/utils/logger';

export const GuideContentWrap = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 770px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
`;

interface GuideCategoryProps {
  entryStep?: boolean;
  category: CategoryData;
  guides?: GuideData[];
  nextStep?: string | null;
  pdfs?: PdfData[];
}

export default function GuideCategory({
  entryStep = false,
  category,
  guides,
  nextStep = null,
  pdfs,
}: GuideCategoryProps) {
  if (!category) {
    log.error('Category is not defined');
    return null;
  }

  if (!guides) {
    log.error('Guides are not defined');
    return null;
  }

  return (
    <ManualMainMain>
      <ManualMain
        style={{
          overflowY: 'auto',
        }}
      >
        <GuideContentWrap>
          <Header entryStep={entryStep} guides={guides} category={category} nextStep={nextStep} pdf={pdfs?.[0]} />

          <Box mt={2}>
            {/* <Typography variant="body1" component="p">
              {category.content}
            </Typography> */}
            <ParsedContent content={category.content} />
          </Box>

          {guides.length != 1 && (
            <Box mt={3}>
              <ListOfGuides guides={guides} />
            </Box>
          )}

          <div style={{ height: '50px' }} />
        </GuideContentWrap>
      </ManualMain>
    </ManualMainMain>
  );
}
